import React from 'react'
import { Nav, Navbar } from 'react-bootstrap'

import { HashLink } from 'react-router-hash-link'
import './Menu.css'
const Menu = () => {
  return (
    <header
      style={{
        position: 'sticky',
        top: '0',
        width: '100%',
        backgroundColor: '#fff',
        zIndex: '5',
      }}
    >
      <Navbar sticky='top' collapseOnSelect expand='lg' variant='dark'>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='text-center m-auto'>
            <Nav.Link as={HashLink} to='/home#home'>
              Home
            </Nav.Link>
            <Nav.Link as={HashLink} to='/home#about'>
              About
            </Nav.Link>
            <Nav.Link as={HashLink} to='/home#project'>
              project
            </Nav.Link>
            {/* <Nav.Link as={HashLink} to='/home#myBlog'>
              blog
            </Nav.Link> */}

            <button className='button-cv'>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://drive.google.com/file/d/1LXHOLfSNPXqytVaJAWK5D6-qrwXESQfy/view?usp=sharing'
              >
                Download CV
              </a>
            </button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

export default Menu
